import React from 'react';
import FSButton from '../../../components/FSButton';
function Tabs(_a) {
    var tabNames = _a.tabNames, selected = _a.selected, onTabChange = _a.onTabChange;
    var tabs = tabNames.map(function (t) { return (React.createElement(FSButton, { key: t, style: { marginRight: 15 }, "$type": "tertiary", title: t, onClick: function () { return onTabChange(t); }, disabled: selected === t })); });
    return React.createElement("div", { style: { marginBottom: 15, display: 'flex' } }, tabs);
}
export default Tabs;
